import React, { useCallback, useEffect, useState } from 'react'
import styles from './login.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as yup from "yup";
import { Checkbox, CircularProgress, } from '@mui/material';
import { ArrowIcon, BackArrowIcon, HidePasswordIcon, LogoIcon, PasswordVisible } from '../../../svg';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../redux/loginSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const ResetPassword = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation()
    const email = location?.state?.item;
    
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    // schema -----------
    const schema = yup.object().shape({
        password: yup.string().required("Password is required"),
        confirmPassword: yup.string().required("Confirm Password is required"),
    })

    const {
        errors, values, handleChange, touched, setFieldValue, handleBlur, resetForm, handleSubmit,
    } = useFormik({
        initialValues: {
            password: "",
            confirmPassword: "",
        },
        validationSchema: schema,
        onSubmit: (values) => {
            handleLogin({...values, email:email});
        }
    })

    
    const handleLogin = useCallback(async (values) => {
        setLoading(true);
        try {
            const result = await dispatch(resetPassword(values));
            unwrapResult(result)
            navigate('/success');
            // navigate("")
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    }, [dispatch, navigate]);

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.mainContainer}>
                    <LogoIcon />
                </div>
                <div className={styles.login}>
                    <div className={styles.mobileViewLogin}>
                        <div className={styles.mobileLogoStyle}>
                            <h3>KINGSTER</h3>
                        </div>
                    </div>
                    <div className={styles.content} style={{ marginTop: 20 }}>
                        <div onClick={() => navigate('/')} className={styles.backArrowStyle}><BackArrowIcon /> <span className={styles.backToLogin}>Back to Login</span></div>
                        <div onClick={() => navigate('/')} className={styles.backArrow}><BackArrowIcon /><h3>Reset Password</h3></div>
                        <h3 style={{ marginTop: 50 }} className={styles.forgotPassword}>Reset Password?</h3>
                        <p style={{ marginTop: 20 }}>Please enter the new password</p>
                        <div style={{ marginTop: 20 }}>
                            <label className={styles.label}>Password</label>
                            <div className={styles.inputbox}>
                                <input
                                    type={showNewPassword ? 'text' : 'password'}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    placeholder='password'
                                    name="password"
                                    onChange={handleChange}
                                />
                                <div onClick={() => setShowNewPassword(!showNewPassword)}>
                                    {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                </div>
                            </div>
                            {
                                errors.password && touched.password && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.password}</p>
                            }
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <label className={styles.label}>Confirm Password</label>
                            <div className={styles.inputbox}>
                                <input
                                    type={showNewPassword ? 'text' : 'password'}
                                    onBlur={handleBlur}
                                    value={values.confirmPassword}
                                    placeholder='password'
                                    name="confirmPassword"
                                    onChange={handleChange}
                                />
                                <div onClick={() => setShowNewPassword(!showNewPassword)}>
                                    {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                </div>
                            </div>
                            {
                                errors.confirmPassword && touched.confirmPassword && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.confirmPassword}</p>
                            }
                        </div>
                        <div className={styles.google}>
                            <div className={styles.saveButtonStyle} onClick={handleSubmit} disabled={loading} style={{ marginTop: 30 }}>
                                {
                                    loading ?
                                        <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                        : "Submit"
                                } <ArrowIcon />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}



export default ResetPassword;
